// Мапперы для Notification согласно STYLEGUIDE.md
import type { Notification, DbNotification, NotificationCreate, NotificationUpdate } from '@/types/entities/notification';

/**
 * Конвертация из БД (snake_case) в клиентский формат (camelCase)
 */
export const dbNotificationToNotification = (dbNotification: DbNotification): Notification => ({
  id: dbNotification.id,
  userId: dbNotification.user_id,
  title: dbNotification.title,
  message: dbNotification.message,
  type: dbNotification.type,
  read: !!dbNotification.read,
  createdAt: new Date(dbNotification.created_at),
  readAt: dbNotification.read_at ? new Date(dbNotification.read_at) : undefined,
  entityType: dbNotification.entity_type,
  entityId: dbNotification.entity_id,
  priority: dbNotification.priority,
  data: dbNotification.data,
});

/**
 * Конвертация из клиентского формата (camelCase) в БД (snake_case)
 */
export const notificationToDbNotification = (notification: Notification): DbNotification => ({
  id: notification.id,
  user_id: notification.userId,
  title: notification.title,
  message: notification.message,
  type: notification.type,
  read: notification.read,
  created_at: notification.createdAt.toISOString(),
  read_at: notification.readAt ? notification.readAt.toISOString() : undefined,
  entity_type: notification.entityType,
  entity_id: notification.entityId,
  priority: notification.priority,
  data: notification.data,
});

/**
 * Конвертация данных создания в формат БД
 */
export const notificationCreateToDb = (create: NotificationCreate): Omit<DbNotification, 'id' | 'user_id' | 'read' | 'created_at' | 'read_at'> => ({
  title: create.title,
  message: create.message,
  type: create.type,
  entity_type: create.entityType,
  entity_id: create.entityId,
  priority: create.priority,
  data: create.data,
});

/**
 * Конвертация данных обновления в формат БД
 */
export const notificationUpdateToDb = (update: NotificationUpdate): Partial<Omit<DbNotification, 'id' | 'user_id' | 'created_at'>> => {
  const dbUpdate: Partial<Omit<DbNotification, 'id' | 'user_id' | 'created_at'>> = {};
  
  if (update.title !== undefined) dbUpdate.title = update.title;
  if (update.message !== undefined) dbUpdate.message = update.message;
  if (update.type !== undefined) dbUpdate.type = update.type;
  if (update.read !== undefined) dbUpdate.read = update.read;
  if (update.readAt !== undefined) dbUpdate.read_at = update.readAt;
  if (update.entityType !== undefined) dbUpdate.entity_type = update.entityType;
  if (update.entityId !== undefined) dbUpdate.entity_id = update.entityId;
  if (update.priority !== undefined) dbUpdate.priority = update.priority;
  if (update.data !== undefined) dbUpdate.data = update.data;
  
  return dbUpdate;
};
